import '../../App.css'
import { useState } from 'react';
import { FaUser } from "react-icons/fa";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import Appconfig from '../../config/config'
import axios from 'axios';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth()
  const [user_nameValidationError, setUser_NameValidationError] = useState("Please enter username");
  const [passwordValidationError, setPasswordValidationError] = useState("Please enter password");
  const [validationError, setValidationError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [welcomeMessage, setWelcomeMessage] = useState("")
  const [formData, setformData] = useState({
    user_name: '',
    password: '',
    site_code: Appconfig.sitecodes,
    user_type: "Super"
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  function checkValidation() {
    if (formData.user_name.trim() === "") {
      setUser_NameValidationError('Please enter username')
    }
    if (formData.password === "") {
      document.querySelector('.password-error').classList.remove('hidden');
      setPasswordValidationError('Please enter password')
    }
    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(formData.user_name)) {
      document.querySelector('.username-error').classList.remove('hidden');
      setUser_NameValidationError('Username is only allow a-z and 0-9.')
      return false;
    }
    if (regex.test(formData.user_name) && formData.password !== "") {
      return true
    }
  }

  const handleInputChange = (event) => {
    setformData({
      ...formData,
      [event.target.name]: event.target.value
    });
    if (event.target.name === 'user_name') {
      document.querySelector('.username-error').classList.add('hidden');
    }
    if (event.target.name === 'password') {
      document.querySelector('.password-error').classList.add('hidden');
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (checkValidation()) {
      const config = {
        method: 'post',
        url: `${Appconfig.apiUrl}users/userAuthenticate`,
        headers: { 'Content-Type': 'application/json' },
        data: JSON.stringify(formData)
      };

      axios(config)
        .then(function (response) {
          formData.user_name = "";
          formData.password = "";
          if (response.data.result) {
            storeUserinfo(response.data.resultData);
          } else {
            setValidationError(response.data.resultMessage);
            errorNotification();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }

  function storeUserinfo(userdata) {
    login(userdata);
    setWelcomeMessage(`Welcome, ${userdata.user_name || formData.user_name}!`);
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
      navigate('/');
    }, 4000);
  }

  const errorNotification = () => {
    NotificationManager.error('Invalid Login Credential!', '', 3000);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-[#0f172a] via-[#146578] to-[#0f172a] min-h-screen px-4">
      {/* Premium Loader */}
      {isLoading && (
        <div className="fixed inset-0 flex flex-col items-center justify-center bg-black/80 z-50 animate-fadeIn">
          {/* Glowing loader */}
          <div className="relative w-24 h-24 mb-6">
            <div className="absolute inset-0 rounded-full border-4 border-t-[#f9df10] border-r-transparent border-b-[#5ecbdd] border-l-transparent animate-spin"></div>
            <div className="absolute inset-4 rounded-full border-4 border-dashed border-[#5ecbdd] animate-spin-slow"></div>
          </div>
          <h2 className="text-3xl font-bold text-white drop-shadow-lg">{welcomeMessage}</h2>
          <p className="text-[#f9df10] text-sm mt-2 animate-pulse">Loading your dashboard...</p>
        </div>
      )}

      {/* Login Modal */}
      {!isLoading && (
        <div className="w-full max-w-[420px] bg-white/10 backdrop-blur-lg rounded-2xl shadow-[0_0_30px_rgba(0,0,0,0.5)] p-8 flex flex-col items-center border border-[#5ecbdd]/40 animate-fadeIn">
          <img
            src="/logo.png"
            alt="Logo"
            className="w-[160px] h-auto mb-6 drop-shadow-xl"
          />

          <form
            method="post"
            onSubmit={handleSubmit}
            autoComplete="off"
            noValidate
            className="w-full flex flex-col gap-6"
          >
            {/* Username */}
            <div>
              <div className="relative flex items-center bg-white/90 rounded-lg overflow-hidden shadow-inner focus-within:ring-2 focus-within:ring-[#f9df10]">
                <input
                  value={formData.user_name}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    if (!e.target.value.trim()) {
                      document.querySelector('.username-error').classList.remove('hidden');
                    }
                  }}
                  type="text"
                  name="user_name"
                  placeholder="Username"
                  maxLength={30}
                  autoFocus
                  className="w-full px-4 py-3 text-black text-sm outline-none bg-transparent"
                />
                <button type="button" className="px-3 text-gray-600 text-lg">
                  <FaUser />
                </button>
              </div>
              <span className="username-error hidden text-xs text-[#f9df10] mt-1 block">
                {user_nameValidationError}
              </span>
            </div>

            {/* Password */}
            <div>
              <div className="relative flex items-center bg-white/90 rounded-lg overflow-hidden shadow-inner focus-within:ring-2 focus-within:ring-[#f9df10]">
                <input
                  value={formData.password}
                  onChange={handleInputChange}
                  onBlur={(e) => {
                    if (!e.target.value.trim()) {
                      document.querySelector('.password-error').classList.remove('hidden');
                    }
                  }}
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  minLength={6}
                  className="w-full px-4 py-3 text-black text-sm outline-none bg-transparent"
                />
                <button
                  type="button"
                  className="px-3 text-gray-600 text-lg"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
              <span className="password-error hidden text-xs text-[#f9df10] mt-1 block">
                {passwordValidationError}
              </span>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full flex items-center justify-center bg-gradient-to-r from-[#f9df10] to-yellow-400 text-black font-bold text-base rounded-lg py-3 shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all"
            >
              Login
              <svg
                className="ml-2"
                width="12"
                height="12"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                  fill="currentColor"
                  fillRule="evenodd"
                />
              </svg>
            </button>
          </form>
        </div>
      )}
      <NotificationContainer />
    </div>
  )
}

export default Login;
